import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import React, { PropsWithChildren, forwardRef } from "react";
import { isInverted } from "../utilities";
import { BackgroundPattern, BackgroundVariant, SerifColor } from "./types";
import { getBackground, getBorder, getPatterns } from "./utilities";
export interface BackgroundType {
  variant?: BackgroundVariant | null;
  pattern?: BackgroundPattern | null;
  serifColor?: SerifColor | null;
  border?: boolean | null;
}
interface BackgroundProps {
  as?: React.ElementType;
  background: BackgroundType | null | undefined;
  className?: string;
  id?: string;
}
const Background = forwardRef<HTMLElement, PropsWithChildren<BackgroundProps>>(function Background(t0, ref) {
  const $ = _c(17);
  const {
    background,
    as,
    className,
    children,
    id
  } = t0;
  const backgroundColor = background?.variant;
  const pattern = background?.pattern;
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== as || $[1] !== background || $[2] !== backgroundColor || $[3] !== className || $[4] !== id || $[5] !== pattern || $[6] !== ref) {
    const bgClass = getBackground(backgroundColor);
    const patternClass = getPatterns(backgroundColor, pattern);
    const inverted = isInverted(background);
    const borderClass = background?.border ? getBorder(backgroundColor) : "";
    const Component = as ?? "section";
    T0 = Component;
    t1 = ref;
    t2 = id;
    t3 = clsx(bgClass, patternClass, borderClass, {
      "text-neutral-0": inverted
    }, className);
    $[0] = as;
    $[1] = background;
    $[2] = backgroundColor;
    $[3] = className;
    $[4] = id;
    $[5] = pattern;
    $[6] = ref;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    T0 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[11] !== T0 || $[12] !== children || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <T0 ref={t1} id={t2} className={t3}>{children}</T0>;
    $[11] = T0;
    $[12] = children;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
});
export default Background;